const whiteList = [
  'https://development.chandon.com',
  'https://staging.chandon.com',
  'https://www.chandon.com',
  'http://localhost:8080'
]

export const sendMessage = (message) => {
  let origin = window.location !== window.parent.location
    ? document.referrer
    : document.location.origin
  origin = new URL(origin).origin

  if (!whiteList.includes(origin)) {
    return
  }

  parent.postMessage(message, origin)
}
